import $ from 'jquery';
import { init_product_add_to_cart } from "./product-add-to-cart";
import { init_counter_add_to_cart } from "./counter";

export default function initPanels() {
	let $panels = $('.expansion-panel');
	$panels.each((i, panel) => {
		if ($(panel).data('initialized') !== true) {
			$(panel).on('click', e => {
				if ($(e.target).hasClass('button--download')) {
					window.open(psh_vars.rest_route.psh_download_pdf + `&orderNumber=${$(panel).data('order-number')}` + `&type=DownloadInvoice`);
					return;
				}
				if ($(e.target).hasClass('button--pakbon')) {
					window.open(psh_vars.rest_route.psh_download_pdf + `&orderNumber=${$(panel).data('order-number')}` + `&type=DownloadDespatchAdvice`);
					return;
				}
				if (($(e.target).closest('.expansion-panel__collapsed').length > 0) || $(panel).hasClass('not-found')) {
					return;
				}

				if ($(panel).data('loading') !== true && $(panel).data('type') === 'order') {
					toggleExpandableContentOrder($(panel));
				}
				if ($(panel).data('loading') !== true && $(panel).data('type') === 'product') {
					toggleExpandableContentProduct($(panel));
				}
			});
			$(panel).data('initialized', true);
		}
	});
}

initPanels();

function toggleExpandableContentOrder($panel) {

	if ($panel.data('loaded') !== true) {
		const template = wp.template('order-detail-item');

		$.ajax({
			type: "GET",
			url: psh_vars.rest_route.psh_order_details,
			data: {
				order_number: $panel.data('order-number'),
			},
			beforeSend: function () {
				$panel.addClass('loading');
				$panel.data('loading', true);
			},
			success: function (data) {
				let currency = data.order_details.Currency,
				    order_number = data.order_details.OrderNumber;

				if(data.order_details.Lines) {
					data.order_details.Lines.forEach(line => {
						const data = {
							line,
							currency,
							order_number
						};
						$panel.find('.table__items').append(template(data));
					});
				} else {
					let content = {}
					$panel.find('.table__items').append(template(content));
				}

				$panel.data('loaded', true);
				$panel.data('loading', false);
				$panel.addClass('expanded');
				$panel.removeClass('loading');

				let actions = $panel.find('.my-orders__expansion-panel__collapsed__button');
				if ( data.order_details.InvoiceNumber ) {
					actions.append( '<a class="button button--download">'+ psh_vars.download_invoice +'</a>' );
				}
				if ( data.order_details.DespatchAdviceNumber ) {
					actions.append( '<a class="button button--pakbon">'+ psh_vars.download_etiquette +'</a>' );
				}
				if ( data.order_details.TrackAndTraceUrl ) {
					actions.append( '<a target="_blank" class="button button--track-and-trace" href="' + data.order_details.TrackAndTraceUrl + '">'+ psh_vars.track_and_trace +'</a>' );
				}
			},
			error: function () {
				let content = {}
				$panel.find('.table__items').append(template(content));

				$panel.data('loaded', true);
				$panel.data('loading', false);
				$panel.addClass('expanded');
				$panel.removeClass('loading');
			}
		});
	} else {
		if ($panel.hasClass('expanded')) {
			$panel.removeClass('expanded');
		} else {
			$panel.addClass('expanded');
		}
	}
}

function toggleExpandableContentProduct($panel) {
	if ($panel.data('loaded') !== true) {
		$.ajax({
			type: "GET",
			url: psh_vars.rest_route.psh_part_details,
			data: {
				original_number: $panel.data('original-number'),
			},
			beforeSend: function () {
				$panel.addClass('loading');
				$panel.data('loading', true);
			},
			success: function (data) {
				const categories = data.categories;

				if (categories.length === 0) {
					$panel.addClass('not-found');
				} else {
					for (const [key, value] of Object.entries(categories)) {
						let template = wp.template('category');
						const category = {
							'name': `${key} (${Object.keys(value).length})`,
							'products': value
						}
						$panel.find('.part__categories').append(template(category));
					}
					new Foundation.Accordion($panel.find('.part__categories'), {});
					$panel.addClass('expanded');
				}
				$panel.data('loaded', true);
				$panel.data('loading', false);
				$panel.removeClass('loading');
				init_product_add_to_cart();
				init_counter_add_to_cart();
			},
		});
	} else {
		if ($panel.hasClass('expanded')) {
			$panel.removeClass('expanded');
		} else {
			$panel.addClass('expanded');
		}
	}

}